import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider, useI18n } from "@/lib/i18n";
import { AuthProvider, useAuthCallback } from "@/lib/auth";
import { SubscriptionProvider } from "@/lib/subscription";
import Dashboard from "@/components/Dashboard";
import PairDetail from "@/components/PairDetail";
import Compare from "@/components/Compare";
import PricingPage from "@/components/PricingPage";
import AdminCoupons from "@/components/AdminCoupons";
import AdminAnalytics from "@/components/AdminAnalytics";
import AdminUsers from "@/components/AdminUsers";
import { BillingSuccess, BillingCancel } from "@/components/BillingResult";
import AccessGate from "@/components/AccessGate";
import FeedbackButton from "@/components/FeedbackButton";
import TradingBackground from "@/components/TradingBackground";
import VisitTracker from "@/components/VisitTracker";
import { Toaster } from "@/components/ui/sonner";

function AuthGate({ children }) {
  const done = useAuthCallback();
  if (!done) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">
        Signing you in…
      </div>
    );
  }
  return children;
}

function AppShell() {
  const { dir } = useI18n();
  return (
    <div className="App font-sans" dir={dir}>
      <TradingBackground />
      <BrowserRouter>
        <VisitTracker />
        <AuthGate>
          <Routes>
            <Route path="/" element={<AccessGate><Dashboard /></AccessGate>} />
            <Route path="/pair/:from/:to" element={<AccessGate><PairDetail /></AccessGate>} />
            <Route path="/compare" element={<AccessGate><Compare /></AccessGate>} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/billing/success" element={<BillingSuccess />} />
            <Route path="/billing/cancel" element={<BillingCancel />} />
            <Route path="/admin/coupons" element={<AdminCoupons />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/users" element={<AdminUsers />} />
          </Routes>
          <FeedbackButton />
        </AuthGate>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <AppShell />
        </SubscriptionProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
